/**
 * Created by SG0949773 on 10/19/2015.
 */
'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Configuration'];
module.exports = angular.module('AVRO.SystemConfiguration.ConfigurationEntity', dependencies).controller('ConfigurationEntityController', require('./controllers/ConfigurationEntityController')).directive('configurationEntity', require('./directives/ConfigurationEntityDirective')).factory('ConfigurationEntityService', require('./services/ConfigurationEntityService'));